import React, {forwardRef} from 'react';
import cn from 'classnames';
import {Grid} from 'ht-styleguide';
import Carousel from '@components/UI/Carousel';
import Review from '@components/UI/Review/Review';
/* Types */
import {RefReference} from 'types/base.types';
/* Styles */
import {Review as ReviewType} from 'types/reviews.types';
import styles from './reviews.module.scss';

type CustomerReviewsProps = {
  className?: string;
  carouselItemStyle?: string;
  reviews: ReviewType[];
  headerText?: string | React.ReactNode;
  removeBackground?: boolean;
  headerStyles?: string;
  itemStyles?: string;
  suppressAddressLine?: boolean;
  slidesToShow?: number;
  dynamicRef?: RefReference<HTMLDivElement>;
  addShadow?: boolean;
};

const CustomerReviews = (
  {
    reviews = [],
    headerText = 'Reviews',
    itemStyles = '',
    carouselItemStyle = '',
    suppressAddressLine = false,
    slidesToShow = 3,
    dynamicRef,
    headerStyles,
    className,
    removeBackground = false,
    addShadow = false,
  }: CustomerReviewsProps,
  ref: RefReference<HTMLDivElement>,
) => {
  const isArray = Array.isArray(reviews);

  if (!isArray || (isArray && reviews!.length === 0)) return null;

  const Reviews = reviews.map(r => (
    <Review addShadow={addShadow} review={r} key={r.id} className={cn(styles.item, itemStyles)} suppressAddressLine={suppressAddressLine} />
  ));

  const wrapperStyles = cn(className, styles.reviews, {
    [styles.reviews__nobackground]: removeBackground,
  });

  return (
    <div className={wrapperStyles} ref={ref || dynamicRef} data-testid="reviews-carousel">
      <Grid.FullWidth>
        <h3 className={headerStyles}>{headerText}</h3>
        <div className={styles.list}>
          <Carousel
            arrows
            equalHeight
            variableWidth={false}
            slidesToShow={slidesToShow}
            slidesToScroll={1}
            infinite={false}
            itemStyle={carouselItemStyle}
            resolutions={{
              840: {
                arrows: false,
                variableWidth: true,
                infinite: true,
                slidesToShow: 1,
              },
            }}
          >
            {Reviews}
          </Carousel>
        </div>
      </Grid.FullWidth>
    </div>
  );
};

export default forwardRef(CustomerReviews);
